import { render, staticRenderFns } from "./MailingList.vue?vue&type=template&id=652a8e39&scoped=true&"
import script from "./MailingList.vue?vue&type=script&lang=js&"
export * from "./MailingList.vue?vue&type=script&lang=js&"
import style0 from "./MailingList.vue?vue&type=style&index=0&id=652a8e39&prod&scoped=true&lang=css&"
import style1 from "./MailingList.vue?vue&type=style&index=1&id=652a8e39&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652a8e39",
  null
  
)

export default component.exports